import React from 'react';
import { HeaderWithFilter, IconWrapper } from '../../../healtheraComponents';
import useLocationQuery from '../../../hooks/useQuery';
import { DASHBOARD_REPORTS_HEADERS } from '../constants';

const ReportsTableHeader = ({ title, orderBy }) => {
  const { query, changeLocationQuery } = useLocationQuery();

  const orderByFieldClickHandler = () => {
    changeLocationQuery({
      ...query,
      order_by: orderBy,
      page: 0,
    });
  };

  const isFilteredByThisField = () => {
    return orderBy === (query.order_by || DASHBOARD_REPORTS_HEADERS.TOTAL);
  };

  return (
    <HeaderWithFilter onClick={orderByFieldClickHandler}>
      <div>{title}</div>
      <IconWrapper open={isFilteredByThisField()} />
    </HeaderWithFilter>
  );
};

export default ReportsTableHeader;
